export const steps = [
  {
    index: 0,
    title: 'Общие сведения',
    content: 'Заполнение основной информации',
    icon: 'md-information-circle',
    component: 'common-info'
  },
  {
    index: 1,
    title: 'Календарный план',
    content: 'Заполнение информации по этапам работ',
    icon: 'md-calendar',
    component: 'roadmap'
  },
  {
    index: 2,
    title: 'Условия приемки и оплаты работ',
    content: 'Указание типа налогообложения и условия закрытия договора',
    icon: 'md-cash',
    component: 'pay-conditions'
  },
  {
    index: 3,
    title: 'Аванс',
    content: 'Указание условия получения аванса',
    icon: 'md-construct',
    component: 'prepaid'
  },
  {
    index: 4,
    title: 'Документы',
    content: 'Прикрепление всех основных документов',
    icon: 'md-document',
    component: 'documents'
  }
]

export const requiredCommonFields = [
  'code',
  'number',
  'name',
  'sign_date',
  'customer_id',
  'performer_id',
  'contract_status_id'
]
